import Footer from "../Footer/Footer";
import "./ParichayaSection.css";

function ParichayaSection() {
  return (
    <div className="parichaya-section">
      {" "}
      <div className="parichaya-section__text-box">
        <h2>परिचय </h2>
        स्‍वावलम्‍बी सहकारी स्‍वावलम्‍बन ,स्‍वउतरदायित्‍व , लोकतन्‍त्र ,समानता,
        समता ,ऐक्‍यबद्‍ता ,ईमान्‍दारीता ,खुलापन सामाजिक उतरदायित्‍व लगायतका
        मुल्‍य बोकी बिभिन्‍न ब्‍यतीहरुले स्‍वेच्छिक रुपमा आप्‍नो सामाजिक आर्थिक
        र संस्कृतिक हितका लागि जम्‍मा भई २०६८।०१।१९ गतेका दिन स्‍थापन गरिएको
        स्‍वायत्त संस्‍था को । स्‍वावलम्‍बी सहकारीको अर्थ सहकार्य, सह अस्‍तित्‍व
        ,समानकार्य वा संग संगै गरिने कामलाई बझाउँदछ । यसरि संग संगै मिलेर काम
        गरी आफ्‍नो आर्थिक ,सामाजिक र संस्‍कृतिक हैसियत माथि उठाउने सामुहित
        प्रयास नै स्‍वावलम्‍बी सहकारीको पहिलो उदेश्‍य हो । सहकारी एक अर्का बिचको
        सहकार्यात्‍मक अवधारणा हो । सहकारीमा ब्‍यतीहरु संगठित भई सदस्‍यको हित
        प्रबर्धन गर्ने कार्य गरिन्‍छ । प्राबिधिक रुपमा यसलाई एउटा ब्‍यवसायिक
        कौशलको रुपमा पनि लिईन्‍छ । एकका लागि सबै र सबैका लागि एक भन्‍ने भावना र
        ब्‍यहार मार्फत ब्‍यती परिवार समाज र समग्र साष्‍ट्रको आर्थिक एबं सामाजिक
        उत्‍थानको लागि गरिने प्रयास नै सहकारी हो । सिमित स्रोत र साधन भएका
        ब्‍यतीहरुको सङगठन हो सहकारी । थोरै थोरै बचत संकलन गरि समुह भित्रकै
        सदस्‍यहरुलाई सहुलियत ब्‍याजदमा कर्जा प्रदान गरी उधमी बन्‍न तथा ब्‍यतीलाई
        आईपर्ने साना -ठुला समस्‍या टार्ने राम्रो माध्‍यम हो सहकारी ।
        स्‍वावलम्‍बीको अवधारणा केवल आर्थिक रुपमा आत्‍मनिर्भर हुनु मात्र होईन ,
        यो मानवको स्वतन्‍त्रता , गौरव र सिर्जनाशील शक्‍तिको मुर्त रुप हो ।
        स्‍वावलम्‍बी हुनका लागी आफुलाई चिन्‍नु आफ्ना कमजोरीहरुलाई स्विकार्नु र
        आफ्ना शक्‍तिहरुलाई विकास गर्नु भन्‍ने बुझिन्‍छ । आफ्नो आर्थिक निर्णय
        आफैं गर्न सक्‍नु आफ्नो रोजगारी आफैं सिर्जना गर्न सक्‍नु र आफ्नो
        भबिष्‍यको बित्तिय जिम्‍मेवारी आफैं लिन सक्‍नु नै स्‍वावलम्‍बी को ठोस रुप
        हो ।
      </div>
      <div className="parichaya-section__image-box">
        <img
          src="assets/images/bhuwan-joshi.png"
          alt="Photo of Mr. Bhuwan Joshi"
        />
      </div>
    </div>
  );
}

export default ParichayaSection;
